import React, { useRef } from "react";
import ImageGallery from "react-image-gallery";
// import Image from "next/image";
import useWindowSize from "../../hooks/useWindowSize";
import { convertToImageKit } from "../../utils/convert-to-imagekit";
import LazyLoad from "react-lazyload";

const ImageSlider = ({ product, slug }) => {
  const ref = useRef(null);
  const [images, setImages] = React.useState([]);
  const size = useWindowSize();
  const alt_image =
    "https://toppng.com/uploads/preview/and-blank-effect-transparent-11546868080xgtiz6hxid.png";

  const fetchImgs = () => {
    const newArr = [];
    product &&
      product.assets &&
      product.assets.length &&
      product.assets.map((item, i) => {
        newArr.push({
          original: convertToImageKit(item.url),
          thumbnail:
            item.type === "video"
              ? product.assets[0].url
              : convertToImageKit(item.url),
          type: item.type,
          index: i,
        });
      });

    setImages([...newArr]);
  };

  React.useEffect(() => {
    fetchImgs();
  }, [slug]);

  const myLoader = ({ src }) => {
    return src + `?tr=w-${size.width}`;
  };

  const renderItem = (item) => {
    if (item.type === "video") {
      return (
        <div style={{ height: "100%", width: "100%" }}>
          <iframe
            title="Product Video"
            width="560"
            height="380"
            src={item.original || alt_image}
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
      );
    }

    return (
      <div
        style={{
          height:
            size && size.width > 600
              ? "24rem"
              : ref.current
              ? ref.current.offsetWidth
              : "18rem",
          position: "relative",
        }}
      >
        {item.index === 0 ? (
          <LazyLoad once>
            {/* <Image
              unoptimized={true}
              loader={myLoader}
              height={384}
              width={384}
              src={item.original}
              alt="Product"
              priority={true}
            /> */}
            <img
              className="mx-auto"
              height={384}
              width={384}
              src={item.original}
              alt="Product"
            />
          </LazyLoad>
        ) : (
          <LazyLoad once>
            {/* <Image
              unoptimized={true}
              loader={myLoader}
              height={384}
              width={384}
              src={item.original}
              alt="Product"
            /> */}
            <img
              className="mx-auto"
              height={384}
              width={384}
              src={item.original}
              alt="Product"
            />
          </LazyLoad>
        )}
      </div>
    );
  };

  return (
    <div ref={ref}>
      <ImageGallery
        showBullets={images.length < 2 ? false : true}
        items={
          size && size.width > 600
            ? images
            : images.filter((img) => img.type !== "video")
        }
        showFullscreenButton={false}
        showPlayButton={false}
        showNav={size && size.width > 600 ? false : true}
        showThumbnails={
          images.length < 2 ? false : size && size.width > 600 ? true : false
        }
        thumbnailPosition="bottom"
        renderItem={renderItem}
      />
    </div>
  );
};

const ImageSliderMemo = React.memo(ImageSlider, (preProps, nextProps) => {
  if (JSON.stringify(preProps.product) !== JSON.stringify(nextProps.product))
    return true;
  return false;
});

export default ImageSlider;
